// extracted by mini-css-extract-plugin
export var statItem = "_cd-1";
export var statsRow = "_cd-0";